/**
 * Ajoute une classe `parentLink` aux `li` parents et un élément `<span class="niveauEnfant"></span>` aux liens pour
 * les sous-menus.
 *
 * @param {string} selecteurElements Le sélecteur CSS des éléments du menu.
 */
const enrichirMenu = selecteurElements => {
    $(selecteurElements).each(function() {
        // On met la classe parentLink sur les li qui contiennent des sous-ul
        $(this)
            .parent("li")
            .addClass("parentLink");
        // On rajoute la petite fleche qui servira pour naviguer dans les niveaux sur mobile
        $(this)
            .parent("li")
            .children("a")
            .append('<span class="niveauEnfant"></span>');
    });
};

/**
 * Ouvre le menu mobile au clic.
 *
 * @param {string} selecteurBouton Le sélecteur CSS du bouton sur lequel écouter le clic.
 */
const ouvrirMenuAuClic = selecteurBouton => {
    $(selecteurBouton).on("click", function() {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $("body").removeClass("noScroll");
        } else {
            $(this).addClass("active");
            $("body").addClass("noScroll");
        }
    });
};

/**
 * Ouvre les élements du sous-menu.
 *
 * @param {string} selecteurNiveauEnfant Le sélecteur CSS des éléments du sous-menu.
 * @param {number} mobileBreakPoint Le breakpoint pour les écrans mobiles.
 * @param {bool} animEnCours Indique si une animation est en cours.
 */
const ouvrirSousMenuAuClic = (
    selecteurNiveauEnfant,
    mobileBreakPoint,
    animEnCours
) => {
    $(selecteurNiveauEnfant).on("click", function() {
        if (window.innerWidth < mobileBreakPoint && $(this).parent().hasClass("parentLink")) {
            if (
                $(this)
                    .closest("li")
                    .children("ul").length > 0 &&
                !animEnCours
            ) {
                animEnCours = true;
                let nomParent = $(this).html();
                let urlParent = $(this).attr("href");
                $(this)
                    .closest("li")
                    .children("ul")
                    .prepend(
                        `<li class="menuSite-voir"><a href="${urlParent}" title="voir tout">Voir tout : ${nomParent} </a></li>`
                    );
                $(this)
                    .closest("li")
                    .children("ul")
                    .prepend(
                        '<li class="menuSite-retour"><a href="${urlParent}" title="Retour au menu précédent">Retour</a></li>'
                    );
                    
                $(this)
                    .closest("li")
                    .children("ul")
                    .css("display", "block");
                $(".menuSite-interne")
                    .stop(true, true)
                    .animate(
                        {
                            left: "-=100%"
                        },
                        400,
                        () => {
                            animEnCours = false;
                        }
                    );
                return false;
            }
            return true;
        }
    });
    return false;
};

/**
 * Gère le clic sur la flèche de retour du menu mobile.
 *
 * @param {bool} animEnCours Indique si une animation est en cours.
 */
const retourMenuAuClic = animEnCours => {
    $(".menuSite ul li").on("click", ".menuSite-retour", function() {
        const retour = $(this);
        if (!animEnCours) {
            animEnCours = true;
            $(".menuSite-interne")
                .stop(true, true)
                .animate(
                    {
                        left: "+=100%"
                    },
                    400,
                    () => {
                        retour.parent("ul").css("display", "none");
                        retour.remove();
                        animEnCours = false;
                    }
                );
        }
        return false;
    });
    return false;
};

export {
    enrichirMenu,
    ouvrirMenuAuClic,
    ouvrirSousMenuAuClic,
    retourMenuAuClic
};
